/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface MaldoPay
 */
export class MaldoPay {
    /**
     *
     * @type {string}
     * @memberof MaldoPay
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof MaldoPay
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof MaldoPay
     */
    type: string;
    /**
     *
     * @type {number}
     * @memberof MaldoPay
     */
    clientId: number;
    /**
     *
     * @type {number}
     * @memberof MaldoPay
     */
    brandId: number;
    /**
     *
     * @type {number}
     * @memberof MaldoPay
     */
    integrationId: number;
    /**
     *
     * @type {boolean}
     * @memberof MaldoPay
     */
    amountFromDB?: boolean;
    /**
     *
     * @type {string}
     * @memberof MaldoPay
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof MaldoPay
     */
    apiKey: string;
    /**
     *
     * @type {Array<number>}
     * @memberof MaldoPay
     */
    services: Array<number>;
    /**
     *
     * @type {boolean}
     * @memberof MaldoPay
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof MaldoPay
     */
    autoApprove: boolean;
}
